module.exports = __webpack_public_path__ + "img/page-22.4a8c3719.jpg";